// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".half-circle-spinner .circle-1{border-top-color:#76bc21!important}.half-circle-spinner .circle-2{border-bottom-color:#fce200!important}", ""]);
// Exports
module.exports = exports;
